export const UPDATE_USER_PREFERENCES = 'UPDATE_USER_PREFERENCES' as const;
export const UPDATE_USER_PREFERENCES_COMPLETED = 'UPDATE_USER_PREFERENCES_COMPLETED' as const;
export const UPDATE_USER_PREFERENCES_FAILED = 'UPDATE_USER_PREFERENCES_FAILED' as const;
export const LOAD_LOCAL_USER_PREFERENCES = 'LOAD_LOCAL_USER_PREFERENCES' as const;
export const GET_USER_PREFERENCES = 'GET_USER_PREFERENCES' as const;
export const GET_USER_PREFERENCES_COMPLETED = 'GET_USER_PREFERENCES_COMPLETED' as const;
export const GET_USER_PREFERENCES_FAILED = 'GET_USER_PREFERENCES_FAILED' as const;
export const STAGE_USER_PREFERENCES = 'STAGE_USER_PREFERENCES' as const;
export const COMMIT_PREFERENCES = 'COMMIT_PREFERENCES' as const;
